import { z } from 'zod';
import { ExperienceEditSchema } from '@axiom/validation';

export const FocusAreasSectionSchema = ExperienceEditSchema.pick({
  experiencesFocusAreaOrderPreferences: true,
});

export const ExperienceEditFocusAreasSchema = z.object({
  focusAreas: z
    .array(z.string())
    .min(1, 'Please select at least one focus area'),
});

export const FocusAreasFormSchemaNonAxiom = z
  .object({
    focusAreas: z.array(z.string()),
    noAxiomFocusAreasApply: z.boolean().default(false),
  })
  .superRefine((schema, ctx) => {
    if (!schema.noAxiomFocusAreasApply && schema.focusAreas.length === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message:
          'Please select at least one focus area or indicate that no Axiom focus areas apply.',
        path: ['focusAreas'],
      });
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['noAxiomFocusAreasApply'],
      });
    }
  });
